import React, { ReactElement } from 'react';

import { Info } from 'lucide-react';
import { useIntl } from 'react-intl';

import { QuantityViolation } from 'store/booking-add-ons/types';
import { quantityViolationText } from '../quantity-violation-text';
import { useFocusWhenShown } from '../use-focus-when-shown.hook';

interface QuantityViolationNoticeProps {
  violations: Array<QuantityViolation>;
  className?: string;
  testId: string;
}

export const QuantityViolationNotice = ({
  violations,
  className = '',
  testId,
}: QuantityViolationNoticeProps): ReactElement | null => {
  const intl = useIntl();
  const ref = useFocusWhenShown<HTMLParagraphElement>();

  if (violations.length === 0) {
    return null;
  }

  return (
    <p
      ref={ref}
      tabIndex={-1}
      role="alert"
      className={`mb-0 flex items-start gap-2 rounded-lg bg-muted px-3 py-2 text-sm text-muted-foreground ${className}`}
      data-testid={testId}
    >
      <Info className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <span>{quantityViolationText(intl, violations)}</span>
    </p>
  );
};

export default QuantityViolationNotice;
